import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { CHANNELS } from '@spotahome/ui-library';
import DSIcon from '@spotahome/ui-library/src/base/DSIcon';

const openContractBasicsSimplifiedModal = ({
  chips = [],
  documentChips = [],
  documentsAdditionalInfo = null,
  fullscreenOnMobile = false
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.simplification.bottom.contract-basics.card.title'),
    body: (
      <>
        <p className="contract-basics-simplified-modal__intro">
          {trans('listing.simplification.bottom.contract-basics.modal.intro')}
        </p>
        <div className="contract-basics-simplified-modal__list">
          {chips.map(chip => (
            <div key={chip.name} className="contract-basics-simplified-modal__item">
              <div className="contract-basics-simplified-modal__item-header">
                {chip.icon && <DSIcon name={chip.icon} />}
                {chip.onClick ? (
                  <button
                    type="button"
                    onClick={chip.onClick}
                    className="contract-basics-simplified-modal__item-link"
                  >
                    <strong>{chip.name}</strong>
                  </button>
                ) : (
                  <strong>{chip.name}</strong>
                )}
              </div>
              {chip.description && (
                <p className="contract-basics-simplified-modal__item-description">
                  {chip.description}
                </p>
              )}
            </div>
          ))}
        </div>
        {documentChips.length > 0 && (
          <div className="contract-basics-simplified-modal__documents">
            <div className="contract-basics-simplified-modal__documents-header">
              <DSIcon name="description" />
              <strong>
                {trans(
                  'listing.simplification.bottom.contract-basics.documents.title'
                )}
              </strong>
            </div>
            <ul className="contract-basics-simplified-modal__documents-list">
              {documentChips.map(doc => (
                <li key={doc.name}>{doc.name}</li>
              ))}
            </ul>
          </div>
        )}
        {documentsAdditionalInfo && (
          <div className="contract-basics-simplified-modal__documents">
            <div className="contract-basics-simplified-modal__documents-header">
              <DSIcon name="description" />
              <strong>
                {trans(
                  'listing.simplification.bottom.contract-basics.other-documents.title'
                )}
              </strong>
            </div>
            <p>{documentsAdditionalInfo}</p>
          </div>
        )}
      </>
    ),
    fullscreenOnMobile
  });
};

export default openContractBasicsSimplifiedModal;
